/* eslint-disable arrow-body-style */
import React from 'react';
import PropTypes from 'prop-types';
import { translateElementChildren } from 'utils/translation';

const H3 = ({ children, translationKey, defaultText, ...rest }) => {
  return (
    <h3 {...rest}>
      {translateElementChildren(children, translationKey, defaultText)}
    </h3>
  );
};

H3.propTypes = {
  children: PropTypes.node.isRequired,
  translationKey: PropTypes.string,
  defaultText: PropTypes.string,
};

export default H3;
